import types from './types';

const defaultState = {
  isLoading: false,
  requiredLmsCourses: null
};

export default (state = defaultState, { type, data, ...action }) => {
  switch (type) {
    case types.GET_REQUIRED_LMS_COURSES:
      return { ...state, isLoading: true };
    case types.GET_REQUIRED_LMS_COURSES_SUCCESS:
      return { ...state, requiredLmsCourses: data, isLoading: false };
    case types.GET_REQUIRED_LMS_COURSES_FAILURE:
      return { ...state, isLoading: false };

    default:
      return state;
  }
};
